import { getCourseAttributes } from '@/api'
import { ref } from '@vue/composition-api'

const attributes = ref([])
const isLoading = ref(false)

export default function useCourseAttributes () {

  async function loadCourseAttributes (params) {
    isLoading.value = true
    attributes.value = await getCourseAttributes(params) || {}
    isLoading.value = false
  }

  return {
    loadCourseAttributes,
    attributes,
    isLoading,
  }
}
